import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IDiscountAlterationAttributes extends IModelAttributes {
	discountId: string;
	alterationId: string;

	discount: Models.DiscountEntity | Models.IDiscountEntityAttributes;
	alteration: Models.AlterationEntity | Models.IAlterationEntityAttributes;
	discountAmount: number;
}

@entity('DiscountAlteration')
export default class DiscountAlteration extends Model implements IDiscountAlterationAttributes {
	@observable
	@attribute()
	public discountId: string;

	@observable
	@attribute()
	public alterationId: string;

	@observable
	@attribute({ isReference: true })
	public discount: Models.DiscountEntity;

	@observable
	@attribute({ isReference: true })
	public alteration: Models.AlterationEntity;

	@observable
	@attribute()
	public discountAmount: number;

	constructor(attributes?: Partial<IDiscountAlterationAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.discountId) {
				this.discountId = attributes.discountId;
			}
			if (attributes.alterationId) {
				this.alterationId = attributes.alterationId;
			}

			if (attributes.discount) {
				if (attributes.discount instanceof Models.DiscountEntity) {
					this.discount = attributes.discount;
					this.discountId = attributes.discount.id;
				} else {
					this.discount = new Models.DiscountEntity(attributes.discount);
					this.discountId = this.discount.id;
				}
			} else if (attributes.discountId !== undefined) {
				this.discountId = attributes.discountId;
			}

			if (attributes.alteration) {
				if (attributes.alteration instanceof Models.AlterationEntity) {
					this.alteration = attributes.alteration;
					this.alterationId = attributes.alteration.id;
				} else {
					this.alteration = new Models.AlterationEntity(attributes.alteration);
					this.alterationId = this.alteration.id;
				}
			} else if (attributes.alterationId !== undefined) {
				this.alterationId = attributes.alterationId;
			}
			if (attributes.discountAmount) {
				this.discountAmount = attributes.discountAmount;
			}
		}
	}
}
